module.exports = __webpack_public_path__ + "static/media/acit.f39db6a3.png";